(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-PT').replace(/[^a-z0-9]+/g, ' ').trim();
  const shortTitle = value => value.replace(/^ursinho\s*[—–-]\s*/i, '').trim();
  const messages = new Set(['amor', 'amo te', 'avo', 'pai', 'mae', 'principe', 'princesa', 'parabens', 'alguem especial', 'i you', 'no 1 prof']);
  const category = value => /^[a-z]$/.test(value) ? 'letters' : /^(melhor|melhores)\b/.test(value) || messages.has(value) ? 'messages' : 'names';
  if (customElements.get('ursinho-browser')) return;
  customElements.define('ursinho-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.group = 'all';
      this.grid = this.querySelector('[role="list"]');
      this.input = this.querySelector('input[type="search"]');
      this.count = this.querySelector('.ursinho-count');
      this.empty = this.querySelector('.ursinho-empty');
      this.sort = this.querySelector('.ursinho-sort');
      this.error = this.querySelector('.ursinho-error');
      this.collect();
      this.querySelector('.ursinho-tools').hidden = false;
      this.input.addEventListener('input', () => this.filter());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.input.value = ''; this.filter(); }
      });
      this.querySelector('.ursinho-clear').addEventListener('click', () => {
        this.input.value = ''; this.group = 'all'; this.filter(); this.input.focus();
      });
      this.querySelectorAll('[data-group]').forEach(button => button.addEventListener('click', () => {
        this.group = button.dataset.group; this.filter();
      }));
      this.sort.addEventListener('change', () => this.filter());
      this.querySelector('.ursinho-retry').addEventListener('click', () => this.loadAll());
      this.filter();
      this.loadAll();
    }
    collect() {
      this.items = [...this.grid.querySelectorAll('[data-ursinho-item]')].map(node => {
        const name = normalize(shortTitle(node.dataset.title));
        return { node, name, group: category(name), price: Number(node.dataset.price) };
      });
    }
    filter() {
      const query = normalize(this.input.value);
      const words = query.split(' ').filter(Boolean);
      let visible = 0;
      const mode = this.sort.value;
      this.items.sort((a,b) => mode === 'price-up' ? a.price-b.price || a.name.localeCompare(b.name,'pt') : mode === 'price-down' ? b.price-a.price || a.name.localeCompare(b.name,'pt') : a.name.localeCompare(b.name,'pt'));
      const fragment = document.createDocumentFragment();
      this.items.forEach(item => {
        const match = (this.group === 'all' || item.group === this.group) && (!query || (query.length === 1 ? item.name === query : words.every(word => item.name.includes(word))));
        item.node.hidden = !match;
        if (match) visible++;
        fragment.append(item.node);
      });
      this.grid.append(fragment);
      this.querySelectorAll('[data-group]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.group === this.group)));
      this.empty.hidden = visible > 0 || this.loading || !this.complete && Number(this.dataset.pages) > 1;
      this.count.textContent = this.loading ? this.dataset.loading : this.dataset.countLabel.replace('[count]', String(visible));
    }
    async loadAll() {
      const pages = Number(this.dataset.pages);
      if (pages <= 1) { this.complete = true; this.filter(); return; }
      if (this.loading || this.complete) return;
      this.loading = true; this.error.hidden = true; this.filter();
      this.controller = new AbortController();
      try {
        const ids = new Set(this.items.map(item => item.node.dataset.id));
        for (let page = 1; page <= pages; page++) {
          if (page === Number(this.dataset.current)) continue;
          const url = new URL(this.dataset.url, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.searchParams.set('section_id', this.dataset.section);
          url.searchParams.set('page', String(page));
          const response = await fetch(url, {signal:this.controller.signal});
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const root = doc.querySelector('ursinho-browser');
          if (!root) throw new Error('Collection unavailable');
          root.querySelectorAll('[data-ursinho-item]').forEach(node => {
            if (!ids.has(node.dataset.id)) { this.grid.append(document.importNode(node, true)); ids.add(node.dataset.id); }
          });
        }
        this.complete = true;
        const pagination = this.querySelector('.ursinho-pagination');
        if (pagination) pagination.hidden = true;
      } catch (error) {
        if (error.name !== 'AbortError') this.error.hidden = false;
      } finally {
        this.loading = false; this.collect(); this.filter();
      }
    }
  });
})();
